import { useState } from 'react';

import { selectExternalInvitationsForScopes } from '@/domain/external-invitation/external-invitations.selectors';
import { getCategories } from '@/domain/external-invitation/utils/category/get-categories';
import { getScopesFromModeAndSector } from '@/domain/external-invitation/utils/scopes/get-scopes';
import { ScoreType, Sector } from '@/domain/impact/impact.entity';
import { useAppSelector } from '@/ui/hook/store';
import { ImpactQuestionContext } from '@/ui/pages/app/components/quiz-panel/ImpactQuestionContext';
import { QuizPanel } from '@/ui/pages/app/components/quiz-panel/QuizPanel';
import { prepareQuizPanelDescription } from '@/ui/pages/app/components/quiz-panel/utils/prepare-quiz-panel-description';
import { InviteSubmitData } from '@/ui/pages/app/components/stakeholders/assign-external/components/FormExternalInvite';

import { venueStructureCo2FormData } from '../utils/venue-structure-co2-form-data';
import { envVenueStructureQuizLayout } from '../utils/venue-stucture-env-quiz-layout';
import { essVenueStructureQuizLayout } from '../utils/venue-stucture-ess-quiz-layout';

export function VenueStructureQuizPanel({
  projectId,
  selectedTopic,
  selectedSector,
  selectedDetailsValueId,
  onSubmitInvite,
}: {
  projectId: number;
  selectedTopic: ScoreType;
  selectedSector: Sector;
  selectedDetailsValueId: string;
  onSubmitInvite: (data: InviteSubmitData) => void;
}) {
  const [panelOpen, setPanelOpen] = useState(false);
  const [hideCompleted, setHideCompleted] = useState(false);

  const externalCategories = getCategories('venue-structure', selectedSector);
  const externalScopes = getScopesFromModeAndSector(
    'venue-structure',
    selectedSector,
  );
  const externalExistingInvitations = useAppSelector(
    selectExternalInvitationsForScopes(externalScopes),
  );

  const quizPanelDescription = prepareQuizPanelDescription(
    selectedTopic,
    selectedSector,
  );

  return (
    <ImpactQuestionContext.Provider
      value={{
        panelOpen,
        hideCompleted,
        setHideCompleted,
        setPanelOpen,
      }}
    >
      <QuizPanel
        projectId={projectId}
        quizScoreType={selectedTopic}
        quizSubType={selectedDetailsValueId}
        sector={selectedSector}
        externalCategories={externalCategories}
        externalExistingInvitations={externalExistingInvitations}
        onSubmitInvite={onSubmitInvite}
        co2FormData={venueStructureCo2FormData[selectedSector]}
        co2ExternalFormData={undefined}
        description={quizPanelDescription.description}
        descriptionTootltip={quizPanelDescription.descriptionTootltip}
        essQuizLayout={essVenueStructureQuizLayout}
        envQuizLayout={envVenueStructureQuizLayout}
        enableExternalPublic={false}
        enableExternalAnswsersView={false}
      />
    </ImpactQuestionContext.Provider>
  );
}
